<template>
  <div class="">
    <slot name="toolbar-content"></slot>
    <div class="white pa-3">
      <LoaderBox v-if="loading" absolute />
      <div v-if="isSelectedToday">
        <v-stepper v-model="step" non-linear vertical>

          <v-stepper-step step="1" editable color="orange">Clear Yesterday Sale</v-stepper-step>
          <v-stepper-content step="1">
            <v-timeline align-top dense clipped class="ml-2">

              <!-- Section 1 -->

              <v-timeline-item color="green" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>Step 1</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>{{checkClientBuffers.title}}</span>
                      <v-icon class="blue--text pl-3" >fab fa-telegram-plane</v-icon>
                      <small class="green--text pl-3">Telegram</small>
                    </strong>
                    <div class="caption"> {{checkClientBuffers.details}}</div>
                    <div class="button-container">
                      <v-btn color="green" :dark="!checkClientBuffers.disabled" @click="checkClientBuffers.start()" :loading="checkClientBuffers.loading" :disabled="checkClientBuffers.disabled" class="ml-0">
                        {{checkClientBuffers.title}}
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item color="green" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>Step 2</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>{{checkEmptyBots.title}}</span>
                      <v-icon class="blue--text pl-3" >fab fa-telegram-plane</v-icon>
                      <small class="green--text pl-3">Telegram</small>
                    </strong>
                    <div class="caption"> {{checkEmptyBots.details}}</div>
                    <div class="button-container">
                      <v-btn color="green" :dark="!checkEmptyBots.disabled" @click="checkEmptyBots.start()" :loading="checkEmptyBots.loading" :disabled="checkEmptyBots.disabled" class="ml-0">
                        {{checkEmptyBots.title}}
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item color="green" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>Step 3</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>Notify sale balance</span>
                      <v-icon class="blue--text pl-3" >fab fa-telegram-plane</v-icon>
                      <small class="green--text pl-3">Telegram</small>
                    </strong>
                    <div class="caption">
                      <span v-if="notifySaleBalance.activated" class="caption red--text mr-1">(Already run this script)</span>
                      <span>Send balance detail of sale account of the active sale to telegram. (config at sales_bot_balance_notification)</span>
                    </div>
                    <div class="button-container">
                      <v-btn color="green" :dark="!(notifySaleBalance.disabled || notifySaleBalance.timeout !== 0)" @click="requestNotifySaleBalance" :loading="notifySaleBalance.loading || notifySaleBalance.timeout !== 0" :disabled="notifySaleBalance.disabled || notifySaleBalance.timeout !== 0" class="ml-0">
                        Notify sale balance
                        <span v-if="notifySaleBalance.timeout !== 0" slot="loader">Refresh in {{ this.notifySaleBalance.timeout }} seconds</span>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item color="orange" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>Step 4</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>Send Exchanges To Bitstamp</span>
                    </strong>
                    <div class="caption">
                      <span v-if="sendExchangesToBitstamp.activated" class="caption red--text mr-1">(Already run this script)</span>
                      <span>Try to send for each exchanges to Bitstamp manually</span>
                    </div>
                    <div class="button-container">
                      <v-btn color="orange" :dark="!sendExchangesToBitstamp.disabled" @click="requestSendExchangesToBitstamp" :loading="sendExchangesToBitstamp.loading" :disabled="sendExchangesToBitstamp.disabled" class="ml-0">
                        Send Exchanges To Bitstamp
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item color="orange" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>Step 5</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>Send Bitstamp Main To Sub</span>
                    </strong>
                    <div class="caption">
                      <span v-if="sendBitstampMainToSub.activated" class="caption red--text mr-1">(Already run this script)</span>
                      <span>Try to send Bitstamp's main account to sub account manually</span>
                    </div>
                    <div class="button-container">
                      <v-btn color="orange" :dark="!sendBitstampMainToSub.disabled" @click="requestSendBitstampMainToSub" :loading="sendBitstampMainToSub.loading" :disabled="sendBitstampMainToSub.disabled" class="ml-0">
                        Send Bitstamp Main To Sub
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>
            </v-timeline>
          </v-stepper-content>

          <v-stepper-step step="2" editable color="blue">Preparation Process</v-stepper-step>
          <v-stepper-content step="2">
            <v-timeline align-top dense clipped class="ml-2">
              <!-- Section 2 -->

              <v-timeline-item color="green" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>Step 1</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>{{checkClientConfigSummary.title}}</span>
                      <v-icon class="blue--text pl-3" >fab fa-telegram-plane</v-icon>
                      <small class="green--text pl-3">Telegram</small>
                    </strong>
                    <div class="caption">{{checkClientConfigSummary.details}}</div>
                    <div class="button-container">
                      <v-btn color="green" :dark="!checkClientConfigSummary.disabled" @click="checkClientConfigSummary.start()" :loading="checkClientConfigSummary.loading" :disabled="checkClientConfigSummary.disabled" class="ml-0">
                        {{checkClientConfigSummary.title}}
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item color="blue" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>Step 2</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>Wake up</span>
                    </strong>
                    <div class="caption">
                      <span v-if="wakeUp.activated" class="caption red--text mr-1">(Already run this script)</span>
                      <span>Wake up script will be run automatically at 12:00 AM (Chiang Mai time). It will get ripple volume of exchanges.</span>
                    </div>
                    <div class="button-container">
                      <v-btn color="primary" dark @click="requestWakeUp" :loading="wakeUp.loading" :disabled="wakeUp.disabled" class="ml-0">
                        Wake up
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item color="blue" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>Step 3</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>Update wake up</span>
                    </strong>
                    <div class="caption">
                      <span v-if="updateWakeUp.activated" class="caption red--text mr-1">(Already run this script)</span>
                      <span>When you need to change % to sell at <a href="/collection/sale-client-configs" target="_blank">sale-client-configs</a> but it will use the same volume of current <a href="#" @click.prevent="scrollToSaleMonitoring">historical-sales</a>.</span>
                    </div>
                    <div class="button-container">
                      <v-btn color="primary" @click="requestUpdateWakeUp" :loading="updateWakeUp.loading" :disabled="updateWakeUp.disabled" class="ml-0">
                        Update wake up
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item color="grey" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>*Optional</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>{{updateWakeUpSpreadsheet.title}}</span>
                    </strong>
                    <div class="caption" v-html="updateWakeUpSpreadsheet.details"></div>
                    <div class="button-container">
                      <v-btn color="primary" :dark="!updateWakeUpSpreadsheet.disabled" @click="updateWakeUpSpreadsheet.start()" :loading="updateWakeUpSpreadsheet.loading" :disabled="updateWakeUpSpreadsheet.disabled" class="ml-0">
                        {{updateWakeUpSpreadsheet.title}}
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item color="blue" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>Step 5</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>Activate Sale</span>
                    </strong>
                    <div class="caption">
                      <span v-if="activateSale.activated" class="caption red--text mr-1">(Already run this script)</span>
                      <span>After checking on <a href="#" @click.prevent="scrollToSaleMonitoring">historical-sales</a>. If everythings are correct. Clicking this button to set configuration <b>is_active = true</b> for proceed on the next step.</span>
                    </div>
                    <div class="button-container">
                      <v-btn color="primary" @click="requestActivateSale" :loading="activateSale.loading" :disabled="activateSale.disabled" class="ml-0">
                        Activate Sale
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item color="green" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>Step 6</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>Notifier summary</span>
                      <v-icon class="blue--text pl-3" >fab fa-telegram-plane</v-icon>
                      <small class="green--text pl-3">Telegram</small>
                    </strong>
                    <div class="caption">
                      <span v-if="notifierSummaryToTelegram.activated" class="caption red--text mr-1">(Already run this script)</span>
                      <span>Send summary of today sale to telegram. (config at sale_summary_notification)</span>
                    </div>
                    <div class="button-container">
                      <v-btn color="green" :dark="!notifierSummaryToTelegram.disabled" @click="requestNotifierSummaryToTelegram(token)" :loading="notifierSummaryToTelegram.loading" :disabled="notifierSummaryToTelegram.disabled" class="ml-0">
                        Notifier summary
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item color="grey" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>*Optional</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>{{stopTodaySaleBots.title}}</span>
                    </strong>
                    <div class="caption">{{stopTodaySaleBots.details}}</div>
                    <div class="button-container">
                      <v-btn color="red" :dark="!stopTodaySaleBots.disabled" @click="stopTodaySaleBots.start(token)" :loading="stopTodaySaleBots.loading" :disabled="stopTodaySaleBots.disabled" class="ml-0">
                        <span>{{stopTodaySaleBots.title}}</span>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item color="grey" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>*Optional</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>{{startTodaySaleBots.title}}</span>
                    </strong>
                    <div class="caption">{{startTodaySaleBots.details}}</div>
                    <div class="button-container">
                      <v-btn color="red" :dark="!startTodaySaleBots.disabled" @click="startTodaySaleBots.start(token)" :loading="startTodaySaleBots.loading" :disabled="startTodaySaleBots.disabled" class="ml-0">
                        <span>{{startTodaySaleBots.title}}</span>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>
            </v-timeline>
          </v-stepper-content>

          <v-stepper-step step="3" editable color="pink">Dispatch {{this.token}} To Sale</v-stepper-step>
          <v-stepper-content step="3">
            <v-timeline align-top dense clipped class="ml-2">
              <!-- Section 3 -->

              <v-timeline-item color="green" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>Step 1</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>{{checkSendToDaily.title}}</span>
                      <v-icon class="blue--text pl-3" >fab fa-telegram-plane</v-icon>
                      <small class="green--text pl-3">Telegram</small>
                    </strong>
                    <div class="caption">{{checkSendToDaily.details}}</div>
                    <div class="button-container">
                      <v-btn color="green" :dark="!checkSendToDaily.disabled" @click="checkSendToDaily.start()" :loading="checkSendToDaily.loading" :disabled="checkSendToDaily.disabled" class="ml-0">
                        {{checkSendToDaily.title}}
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item color="pink" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>Step 2</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>Send clients to daily</span>
                    </strong>
                    <div class="caption">
                      <span v-if="sendClientsToDaily.activated" class="caption red--text mr-1">(Already run this script)</span>
                      <span>After checking on <a href="#" @click.prevent="scrollToSaleMonitoring">historical-sales</a>. If everythings are correct (check on tab <b>CLIENTS</b> and <b>EXCHANGES</b> and <b>RATE</b>, Clicking this button will send {{this.token}} from buffers to Daily.</span>
                    </div>
                    <div class="button-container">
                      <v-btn
                        :dark="!(sendClientsToDaily.disabled || sendClientsToDaily.timeout !== 0)" 
                        :loading="sendClientsToDaily.loading || sendClientsToDaily.timeout !== 0" 
                        :disabled="sendClientsToDaily.disabled || sendClientsToDaily.timeout !== 0" 
                        color="pink white--text" 
                        @click="requestSendClientsToDaily" 
                        class="ml-0">
                        Send clients to daily
                        <span v-if="sendClientsToDaily.timeout !== 0" slot="loader">Refresh in {{ this.sendClientsToDaily.timeout }} seconds</span>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
                <Dialog
                  ref="sendClientsToDailyDialog"
                  :title="null"
                  submitText="Continue"
                >
                  <div slot="body">
                    <h3>Please check this buffers before continue</h3>
                    <br />
                    <MongoDataTable
                      v-if="sendClientsToDaily.dialog.data"
                      :offline="true"
                      :title="'Client Buffer'"
                      :autoSchema="true"
                      :items="sendClientsToDaily.dialog.data"
                      :syncUserState="false"
                      :insertable="false"
                      :editable="false"
                      :deletable="false"
                      :selectable="false"
                      :refreshable="false"
                      :filterable="false"
                      :columnSelectable="false"
                      :sortable="true"
                      :rowsPerPage="-1"
                      :countable="false"
                      :hideHeaders="false"
                      :hideFooters="true"
                      containerClass="elevation-1"
                      toolbarClass="pt-3"
                    />
                  </div>
                </Dialog>
              </v-timeline-item>

              <v-timeline-item color="pink" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>Step 3</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>Send daily to exchanges</span>
                    </strong>
                    <div class="caption">
                      <span v-if="sendDailyToExchanges.activated" class="caption red--text mr-1">(Already run this script)</span>
                      <span>After checking on <a href="#" @click.prevent="scrollToSaleMonitoring">historical-sales</a>. If everythings are correct (check on tab <b>CLIENTS</b> and <b>EXCHANGES</b> and <b>RATE</b>, Clicking this button will send {{this.token}} from daily to exchanges.</b></span>
                    </div>
                    <div class="button-container">
                      <v-btn color="pink white--text" 
                        :dark="!(sendDailyToExchanges.disabled || sendDailyToExchanges.timeout !== 0)" 
                        @click="requestSendDailyToExchanges" 
                        :loading="sendDailyToExchanges.loading || sendDailyToExchanges.timeout !== 0" 
                        :disabled="sendDailyToExchanges.disabled || sendDailyToExchanges.timeout !== 0" 
                        class="ml-0">
                        Send daily to exchanges
                        <span v-if="sendDailyToExchanges.timeout !== 0" slot="loader">Refresh in {{ this.sendDailyToExchanges.timeout }} seconds</span>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
                <Dialog
                  ref="sendDailyToExchangesDialog"
                  title="Sale Balances"
                  submitText="Continue"
                >
                  <div slot="body">
                    <h3>Please check this balances before continue</h3>
                    <br />
                    <CurrencyBalance v-if="sendDailyToExchanges.dialog.data" :items="sendDailyToExchanges.dialog.data" />
                  </div>
                </Dialog>
              </v-timeline-item>

              <v-timeline-item color="pink" small>
                <v-layout pt-3>
                  <v-flex xs3 hiden-xs-only>
                    <strong>Step 4</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>Update virtualual balance</span>
                    </strong>
                    <div class="caption">
                      <span v-if="updateVirtualBalances.activated" class="caption red--text mr-1"></span>
                      <span>After checking on <a href="#" @click.prevent="scrollToSaleMonitoring">historical-sales</a>., Clicking this button will update {{this.token}} virtual balnces.</b></span>
                    </div>
                    <div class="button-container">
                      <v-btn color="pink white--text" 
                        :dark="!(updateVirtualBalances.disabled)" 
                        @click="requestUpdateVirtualBalances" 
                        class="ml-0">
                        Update Virtual balances
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

            </v-timeline>
          </v-stepper-content>

          <v-stepper-step step="4" editable color="purple">Monitoring</v-stepper-step>
          <v-stepper-content step="4">
            <v-timeline align-top dense clipped class="ml-2">
              <!-- Section 4 -->

              <v-timeline-item color="green" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>Step 1</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>{{checkExecutions.title}}</span>
                      <v-icon class="blue--text pl-3" >fab fa-telegram-plane</v-icon>
                      <small class="green--text pl-3">Telegram</small>
                    </strong>
                    <div class="caption">{{checkExecutions.details}}</div>
                    <div class="button-container">
                      <v-btn color="green" :dark="!checkExecutions.disabled" @click="checkExecutions.start()" :loading="checkExecutions.loading" :disabled="checkExecutions.disabled" class="ml-0">
                        <span>{{checkExecutions.title}}</span>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item color="green" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>Step 2</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>{{checkBotStatus.title}}</span>
                      <v-icon class="blue--text pl-3" >fab fa-telegram-plane</v-icon>
                      <small class="green--text pl-3">Telegram</small>
                    </strong>
                    <div class="caption">{{checkBotStatus.details}}</div>
                    <div class="button-container">
                      <v-btn color="green" :dark="!checkBotStatus.disabled" @click="checkBotStatus.start(token)" :loading="checkBotStatus.loading" :disabled="checkBotStatus.disabled" class="ml-0">
                        <span>{{checkBotStatus.title}}</span>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item color="green" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>Step 3</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>{{notifyBotVirtualBalance.title}}</span>
                      <v-icon class="blue--text pl-3" >fab fa-telegram-plane</v-icon>
                      <small class="green--text pl-3">Telegram</small>
                    </strong>
                    <div class="caption">{{notifyBotVirtualBalance.details}}</div>
                    <div class="button-container">
                      <v-btn color="green" :dark="!notifyBotVirtualBalance.disabled" @click="notifyBotVirtualBalance.start()" :loading="notifyBotVirtualBalance.loading" :disabled="notifyBotVirtualBalance.disabled" class="ml-0">
                        <span>{{notifyBotVirtualBalance.title}}</span>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item color="green" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>Step 4</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>{{notifyAnyBotBalance.title}}</span>
                      <v-icon class="blue--text pl-3" >fab fa-telegram-plane</v-icon>
                      <small class="green--text pl-3">Telegram</small>
                    </strong>
                    <div class="caption">{{notifyAnyBotBalance.details}}</div>
                    <div class="button-container">
                      <v-btn color="green" :dark="!notifyAnyBotBalance.disabled" @click="notifyAnyBotBalance.start()" :loading="notifyAnyBotBalance.loading" :disabled="notifyAnyBotBalance.disabled" class="ml-0">
                        <span>{{notifyAnyBotBalance.title}}</span>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>

              <v-timeline-item color="grey" small>
                <v-layout pt-3>
                  <v-flex xs3 hidden-xs-only>
                    <strong>*Optional</strong>
                  </v-flex>
                  <v-flex xs12 md9>
                    <strong>
                      <span>{{notifyERC20TokenAlert.title}}</span>
                      <v-icon class="blue--text pl-3" >fab fa-telegram-plane</v-icon>
                      <small class="green--text pl-3">Telegram</small>
                    </strong>
                    <div class="caption">{{notifyERC20TokenAlert.details}}</div>
                    <div class="button-container">
                      <v-btn color="green" :dark="!notifyERC20TokenAlert.disabled" @click="notifyERC20TokenAlert.start()" :loading="notifyERC20TokenAlert.loading" :disabled="notifyERC20TokenAlert.disabled" class="ml-0">
                        <span>{{notifyERC20TokenAlert.title}}</span>
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-timeline-item>
            </v-timeline>
          </v-stepper-content>

        </v-stepper>
      </div>
      <div v-else>
        <v-card flat color="grey lighten-5" class="mb-3 pa-3">
          <div class="stepper-content-row" :class="stepperContentClass">
            <div class="button-container">
              <v-btn color="green" :dark="!checkWithdrawRecords.disabled" @click="checkWithdrawRecords.start()" :loading="checkWithdrawRecords.loading" :disabled="checkWithdrawRecords.disabled">
                {{checkWithdrawRecords.title}}
              </v-btn>
              <v-chip label>
                <v-icon left>fab fa-telegram-plane</i></v-icon>
                <span>Telegram</span>
              </v-chip>
            </div>
            <div class="details-container d-flex align-center pa-2">
              <div>{{checkWithdrawRecords.details}}</div>
            </div>
          </div>
        </v-card>
        <v-card flat color="grey lighten-5" class="mb-3 pa-3">
          <div class="stepper-content-row" :class="stepperContentClass">
            <div class="button-container">
              <v-btn color="green" :dark="!checkEstimateBTCResult.disabled" @click="checkEstimateBTCResult.start()" :loading="checkEstimateBTCResult.loading" :disabled="checkEstimateBTCResult.disabled">
                {{checkEstimateBTCResult.title}}
              </v-btn>
              <v-chip label>
                <v-icon left>fab fa-telegram-plane</v-icon>
                <span>Telegram</span>
              </v-chip>
            </div>
            <div class="details-container d-flex align-center pa-2">
              <div>{{checkEstimateBTCResult.details}}</div>
            </div>
          </div>
        </v-card>
        <v-card flat color="grey lighten-5" class="mb-3 pa-3">
          <div class="stepper-content-row" :class="stepperContentClass">
            <div class="button-container">
              <v-btn color="primary" @click="requestSalesResults" :loading="salesResults.loading">
                Sales Results
              </v-btn>
            </div>
            <div class="details-container d-flex align-center pa-2">
              <span>Click this button when the sale is completed and you want to save the sales results data to the database.</span>
            </div>
          </div>
        </v-card>
        <v-card flat color="grey lighten-5" class="mb-3 pa-3">
          <div class="stepper-content-row" :class="stepperContentClass">
            <div class="button-container">
              <v-btn color="green" :dark="!updateResultSpreadsheet.disabled" @click="updateResultSpreadsheet.start()" :loading="updateResultSpreadsheet.loading" :disabled="updateResultSpreadsheet.disabled">
                {{updateResultSpreadsheet.title}}
              </v-btn>
              <v-chip label>
                <v-icon left>fab fa-telegram-plane</v-icon>
                <span>Telegram</span>
              </v-chip>
            </div>
            <div class="details-container d-flex align-center pa-2" v-html="updateResultSpreadsheet.details"></div>
          </div>
        </v-card>
        <v-card flat color="grey lighten-5" class="mb-3 pa-3">
          <div class="stepper-content-row" :class="stepperContentClass">
            <div class="button-container">
              <v-btn color="primary" @click="requestWakeUpDispatch" :loading="wakeUpDispatch.loading">
                Wake Up Dispatch
              </v-btn>
            </div>
            <div class="details-container d-flex align-center pa-2">
              <span>Click this button when you need to wake up dispatch USD to TPW wallet.</span>
            </div>
          </div>
        </v-card>
        <v-card flat color="grey lighten-5" class="mb-3 pa-3">
          <div class="stepper-content-row" :class="stepperContentClass">
            <div class="button-container">
              <v-btn color="primary" @click="requestDispatch" :loading="dispatch.loading">
                Dispatch
              </v-btn>
            </div>
            <div class="details-container d-flex align-center pa-2">
              <span>Click this button when you need to dispatch USD to TPW wallet.</span>
            </div>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
import MongoService from '../../services/mongo.service.js';
import MongoConnector from '../../services/mongo-connector.service';
import { getDefaultConnectorSchema } from '../../configs/schemas';
import MessageDialog from '../../libs/message-dialog';
import { getProp, flattenObject, titleText } from '../../libs/utils';
import LoaderBox from '../../components/LoaderBox';
import CurrencyBalance from '../../components/CurrencyBalance';
import Dialog from '../../components/Dialog';
import MongoDataTable from '../../components/mongo-datatable/MongoDataTable';
const showSuccessMessage = async (
  verifyText = '',
  successMessage = '',
  fn = async () => {},
  html
) => {
  const result = await MessageDialog.showMessage({
    title: 'Are you sure to do this action?',
    html:
      html ||
      `Please enter <b>${verifyText}</b> on message box below to continue.`,
    input: 'text',
    showCancelButton: true
  });
  if (result.hasOwnProperty('value')) {
    if ((result.value || '').toUpperCase() === verifyText) {
      await fn();
      MessageDialog.showSuccessMessage({ text: successMessage });
    } else {
      MessageDialog.showErrorMessage({
        title: 'Action Rejected',
        text: 'Your confirmation message is invalid.'
      });
    }
  }
};
const parseNotificationResult = ({ notificationName, message }) => {
  return {
    width: '80%',
    html: `
      <div class='v-card theme--dark green lighten-1'>
        <div class='v-card__title title'>${titleText(notificationName)}</div>
        <div class='v-card__text white black--text grey lighten-5'><pre>${message}</pre></div>
      </div>`
  };
};

export default {
  components: { LoaderBox, CurrencyBalance, Dialog, MongoDataTable },
  props: {
    date: { type: String, required: true },
    token: { type: String, required: true, default: 'XRP' },
    datas: { type: Array },
    loading: { type: Boolean, required: false, default: false }
  },
  data() {
    return {
      service: new MongoConnector(
        getDefaultConnectorSchema(undefined, 'historical-sales')
      ),
      step: 0,
      checkClientBuffers: {
        title: 'Check client buffers',
        details:
          'Send ripple wallets balance to telegram. (config at client_buffer_balance)',
        loading: false,
        disabled: false,
        activated: false,
        async start() {
          this.loading = true;
          try {
            const {
              notificationName,
              message
            } = await MongoService.notifier.checkClientBuffers();
            MessageDialog.showSuccessMessage(
              parseNotificationResult({ notificationName, message })
            );
          } catch (e) {
            MessageDialog.showErrorMessage({ text: e.toString() });
          }
          this.loading = false;
        }
      },
      checkEmptyBots: {
        title: 'Check empty bots',
        details: `Send status of sale bot's accounts if withdraw are needed to telegram. (config at sales_bot_balance_ok_alert, sales_bot_balance_not_ok_alert)`,
        loading: false,
        disabled: false,
        activated: false,
        async start() {
          this.loading = true;
          try {
            const {
              notificationName,
              message
            } = await MongoService.notifier.checkEmptyBots();
            MessageDialog.showSuccessMessage(
              parseNotificationResult({ notificationName, message })
            );
          } catch (e) {
            MessageDialog.showErrorMessage({ text: e.toString() });
          }
          this.loading = false;
        }
      },
      checkClientConfigSummary: {
        title: 'Check client config summary',
        details: `Send client config summary of the sale to telegram. (config at review_sale_before_start)`,
        loading: false,
        disabled: false,
        activated: false,
        async start() {
          this.loading = true;
          try {
            const {
              notificationName,
              message
            } = await MongoService.notifier.checkClientConfigSummary();
            MessageDialog.showSuccessMessage(
              parseNotificationResult({ notificationName, message })
            );
          } catch (e) {
            MessageDialog.showErrorMessage({ text: e.toString() });
          }
          this.loading = false;
        }
      },
      checkSendToDaily: {
        title: 'Check send to daily',
        details: `Send the status of daily if there is funds left to dispatch for today sale to telegram. (config at check_send_daily_to_exchange)`,
        loading: false,
        disabled: false,
        activated: false,
        async start() {
          this.loading = true;
          try {
            const {
              notificationName,
              message
            } = await MongoService.notifier.checkSendToDaily();
            MessageDialog.showSuccessMessage(
              parseNotificationResult({ notificationName, message })
            );
          } catch (e) {
            MessageDialog.showErrorMessage({ text: e.toString() });
          }
          this.loading = false;
        }
      },
      checkEstimateBTCResult: {
        title: 'Estimate BTC Result',
        details: `Send the estimation of btc sale of the yesterday sale to telegram. ( config at sales_estimate_btc)`,
        loading: false,
        disabled: false,
        activated: false,
        async start() {
          this.loading = true;
          try {
            const {
              notificationName,
              message
            } = await MongoService.notifier.checkEstimateBTCResult();
            MessageDialog.showSuccessMessage(
              parseNotificationResult({ notificationName, message })
            );
          } catch (e) {
            MessageDialog.showErrorMessage({ text: e.toString() });
          }
          this.loading = false;
        }
      },
      checkWithdrawRecords: {
        title: 'Check withdraw records',
        details: `Send the result of validation of withdraw record's name and on submitting withdraw record to telegram. ( config at validate_withdraw_to_bitstamp )`,
        loading: false,
        disabled: false,
        activated: false,
        async start() {
          this.loading = true;
          try {
            const {
              notificationName,
              message
            } = await MongoService.notifier.checkWithdrawRecords();
            MessageDialog.showSuccessMessage(
              parseNotificationResult({ notificationName, message })
            );
          } catch (e) {
            MessageDialog.showErrorMessage({ text: e.toString() });
          }
          this.loading = false;
        }
      },
      checkExecutions: {
        title: 'Check current bot executions',
        details: `Send detail of bot execution of the time set on config to present time to telegram. (config at monitor_current_sale_target )`,
        loading: false,
        disabled: false,
        activated: false,
        async start() {
          this.loading = true;
          try {
            const {
              notificationName,
              message
            } = await MongoService.notifier.checkExecutions();
            MessageDialog.showSuccessMessage(
              parseNotificationResult({ notificationName, message })
            );
          } catch (e) {
            MessageDialog.showErrorMessage({ text: e.toString() });
          }
          this.loading = false;
        }
      },
      startTodaySaleBots: {
        title: 'Start today sale bots',
        details: `Start bot and send the bot status to telegram.`,
        loading: false,
        disabled: false,
        activated: false,
        async start(token) {
          this.loading = true;
          try {
            await showSuccessMessage(
              new Date().getDate().toString(),
              'Your request has been proceed',
              async () => {
                await MongoService.botControl.startTodaySaleBots({currency: token});
              },
              'Please enter today date number before continue.<br>e.g. 16 or 31'
            );
          } catch (e) {
            MessageDialog.showErrorMessage({ text: e.toString() });
          }
          this.loading = false;
        }
      },
      stopTodaySaleBots: {
        title: 'Stop today sale bots',
        details: `Stop bot and send the bot status to telegram.`,
        loading: false,
        disabled: false,
        activated: false,
        async start(token) {
          this.loading = true;
          try {
            await showSuccessMessage(
              new Date().getDate().toString(),
              'Your request has been proceed',
              async () => {
                await MongoService.botControl.stopTodaySaleBots({currency: token});
              },
              'Please enter today date number before continue.<br>e.g. 16 or 31'
            );
          } catch (e) {
            MessageDialog.showErrorMessage({ text: e.toString() });
          }
          this.loading = false;
        }
      },
      checkBotStatus: {
        title: 'Check bot status',
        details: `Send bot status to telegram.`,
        loading: false,
        disabled: false,
        activated: false,
        async start(token) {
          this.loading = true;
          try {
            const {
              notificationName,
              message
            } = await MongoService.botControl.checkBotStatus({currency: token});
            MessageDialog.showSuccessMessage(
              parseNotificationResult({ notificationName, message })
            );
          } catch (e) {
            MessageDialog.showErrorMessage({ text: e.toString() });
          }
          this.loading = false;
        }
      },
      notifyBotVirtualBalance: {
        title: 'Virtual balance notification',
        details: `Send virtual balance to telegram. ( config at bot_virtual_balance_notification )`,
        loading: false,
        disabled: false,
        activated: false,
        async start() {
          this.loading = true;
          try {
            const {
              notificationName,
              message
            } = await MongoService.notifier.notifyBotVirtualBalance();
            MessageDialog.showSuccessMessage(
              parseNotificationResult({ notificationName, message })
            );
          } catch (e) {
            MessageDialog.showErrorMessage({ text: e.toString() });
          }
          this.loading = false;
        }
      },
      notifyAnyBotBalance: {
        title: 'Any balance notification',
        details: `Send balance of defined account on the config to telegram. ( config at any_bot_balance_notification )`,
        loading: false,
        disabled: false,
        activated: false,
        async start() {
          this.loading = true;
          try {
            const {
              notificationName,
              message
            } = await MongoService.notifier.notifyAnyBotBalance();
            MessageDialog.showSuccessMessage(
              parseNotificationResult({ notificationName, message })
            );
          } catch (e) {
            MessageDialog.showErrorMessage({ text: e.toString() });
          }
          this.loading = false;
        }
      },
      notifyERC20TokenAlert: {
        title: 'ERC20 Token Alert',
        details: `Keep tracking for ERC20 token create order on 30 mins period.`,
        loading: false,
        disabled: false,
        activated: false,
        async start() {
          this.loading = true;
          try {
            const {
              notificationName,
              message
            } = await MongoService.notifier.notifyERC20TokenAlert();
            MessageDialog.showSuccessMessage(
              parseNotificationResult({ notificationName, message })
            );
          } catch (e) {
            MessageDialog.showErrorMessage({ text: e.toString() });
          }
          this.loading = false;
        }
      },
      updateWakeUpSpreadsheet: {
        title: 'Update wake up spreadsheet',
        details: `Write on spreadsheet &nbsp;<a href='https://docs.google.com/spreadsheets/d/1qRp-SfKINQ_UWoPo_8P70Eu4EJ2EVdVa7ZR2S6klaK4/" target="_blank'>Daily Sale Calculations.</a>`,
        loading: false,
        disabled: false,
        activated: false,
        async start() {
          this.loading = true;
          try {
            await showSuccessMessage(
              'UPDATE_WAKE_UP_SPREADSHEET',
              'Your `Update wake up spreadsheet`\'s request has been proceed',
              async () => {
                await MongoService.sales.updateWakeUpSpreadsheet();
              }
            );
          } catch (e) {
            MessageDialog.showErrorMessage({ text: e.toString() });
          }
          this.loading = false;
        }
      },
      updateResultSpreadsheet: {
        title: 'Update result spreadsheet',
        details: `Write on spreadsheet &nbsp;<a href="https://docs.google.com/spreadsheets/d/1jKMjOnIVpBIPYe3iGVPtPYr2Bc-XnudlrvSHibO2mqA" target="_blank">Daily Sale Result Calculations.</a>`,
        loading: false,
        disabled: false,
        activated: false,
        async start() {
          this.loading = true;
          try {
            await showSuccessMessage(
              'UPDATE_RESULT_SPREADSHEET',
              'Your `Update result spreadsheet`\'s request has been proceed',
              async () => {
                await MongoService.sales.updateResultSpreadsheet();
              }
            );
          } catch (e) {
            MessageDialog.showErrorMessage({ text: e.toString() });
          }
          this.loading = false;
        }
      },
      wakeUp: {
        loading: false,
        disabled: false,
        activated: false
      },
      updateWakeUp: {
        loading: false,
        disabled: false,
        activated: false
      },
      sendExchangesToBitstamp: {
        loading: false,
        disabled: false,
        activated: false
      },
      sendBitstampMainToSub: {
        loading: false,
        disabled: false,
        activated: false
      },
      activateSale: {
        loading: false,
        disabled: false,
        activated: false
      },
      sendClientsToDaily: {
        loading: false,
        disabled: false,
        activated: false,
        timeout: 0,
        dialog: {
          data: null
        }
      },
      notifySaleBalance: {
        loading: false,
        disabled: false,
        activated: false,
        timeout: 0
      },
      sendDailyToExchanges: {
        loading: false,
        disabled: false,
        activated: false,
        timeout: 0,
        dialog: {
          data: null
        }
      },
      updateVirtualBalances: {
        loading: false,
        disabled: false,
        activated: false
      },
      updateSpreadsheet: {
        loading: false,
        disabled: false,
        activated: false
      },
      notifierSummaryToTelegram: {
        loading: false,
        disabled: false,
        activated: false
      },
      salesResults: {
        loading: false,
        disabled: false,
        activated: false
      },
      wakeUpDispatch: {
        loading: false,
        disabled: false,
        activated: false
      },
      dispatch: {
        loading: false,
        disabled: false,
        activated: false
      }
    };
  },
  computed: {
    todayDate() {
      /* tslint:disable-next-line */
      this.date;
      return new Date().toISOString().split('T')[0];
    },
    isSelectedToday() {
      return this.date === this.todayDate;
    },
    stepperContentClass() {
      return this.$vuetify.breakpoint && this.$vuetify.breakpoint.mdAndUp
        ? ''
        : 'd-block';
    }
  },
  watch: {
    date() {
      this.step = 1;
    },
    datas: {
      immediate: true,
      handler(val) {
        this.setUIState(val[0]);
      }
    }
  },
  methods: {
    async setUIState(val) {
      const isActive = getProp(val, 'is_active', false);
      console.log('!!val', !!val)
      this.wakeUp.disabled = false;
      this.wakeUp.activated = !!val;
      this.updateWakeUp.disabled = !this.wakeUp.activated || isActive;
      this.updateWakeUp.activated = isActive;
      this.activateSale.disabled = this.updateWakeUp.disabled || isActive;
      this.activateSale.activated = isActive;
      const clientsToDaily = getProp(val, 'clients_to_daily', []);
      this.sendClientsToDaily.disabled = !isActive;
      this.sendClientsToDaily.activated = clientsToDaily.length > 0;
      const dailyToExchnages = getProp(val, 'daily_to_exchanges', []);
      this.sendDailyToExchanges.disabled = !this.sendClientsToDaily.activated;
      this.sendDailyToExchanges.activated = dailyToExchnages.length > 0;
      this.updateSpreadsheet.disabled = !this.sendDailyToExchanges.activated;
      this.notifierSummaryToTelegram.disabled = !isActive;
      await this.refreshStepperState();
    },
    async refreshStepperState() {
      this.step = 1;
      if (!this.sendClientsToDaily.disabled) {
        this.step = 2;
      }
      if (!this.updateSpreadsheet.disabled) {
        this.step = 3;
      }
    },
    triggerRefreshData() {
      this.$emit('refresh');
    },
    scrollToSaleMonitoring() {
      this.$emit('scrollToSaleMonitoring');
    },
    async setActionTimeout(action = {}, timeout = 60) {
      return new Promise(resolve => {
        action.timeout = timeout;
        const iInterval = setInterval(() => {
          action.timeout--;
          if (action.timeout <= 0) {
            clearInterval(iInterval);
            resolve();
          }
        }, 1000);
      });
    },
    async requestWakeUp() {
      this.wakeUp.loading = true;
      try {
        await showSuccessMessage(
          'WAKE_UP',
          'Your `Wake up`\'s request has been proceed',
          async () => {
            await MongoService.sales.wakeUp({date: this.date, currency: this.token});
            this.triggerRefreshData();
          }
        );
      } catch (e) {}
      this.wakeUp.loading = false;
    },
    async requestUpdateVirtualBalances() {
      this.updateVirtualBalances.loading = true;
      try {
        await showSuccessMessage(
          'UPDATE_VIRTUAL_BALANCES',
          'Update virtual balances request has been proceed',
          async () => {
            await MongoService.sales.updateVirtualBalances({currency: this.token});
            this.triggerRefreshData();
          }
        );
      } catch (e) {}
      this.updateVirtualBalances.loading = false;
    },
    async requestSendExchangesToBitstamp() {
      this.sendExchangesToBitstamp.loading = true;
      try {
        await showSuccessMessage(
          'SEND_EXCHANGES_TO_BITSTAMP',
          'Your `Send Exchanges To Bitstamp`\'s request has been proceed',
          async () => {
            await MongoService.sales.sendExchangesToBitstamp({date: this.date, currency: this.token});
            this.triggerRefreshData();
          }
        );
      } catch (e) {}
      this.sendExchangesToBitstamp.loading = false;
    },
    async requestSendBitstampMainToSub() {
      this.sendBitstampMainToSub.loading = true;
      try {
        await showSuccessMessage(
          'SEND_BITSTAMP_MAIN_TO_SUB',
          'Your `Send Bitstamp Main To Sub`\'s request has been proceed',
          async () => {
            await MongoService.sales.sendBitstampMainToSub({date: this.date, currency: this.token});
            this.triggerRefreshData();
          }
        );
      } catch (e) {}
      this.sendBitstampMainToSub.loading = false;
    },
    async requestUpdateWakeUp() {
      this.updateWakeUp.loading = true;
      try {
        await showSuccessMessage(
          'UPDATE_WAKE_UP',
          'Your `Update Wake up`\'s request has been proceed',
          async () => {
            await MongoService.sales.updateWakeUp({date: this.date, currency: this.token});
            this.triggerRefreshData();
          }
        );
      } catch (e) {}
      this.updateWakeUp.loading = false;
    },
    async requestActivateSale() {
      this.activateSale.loading = true;
      try {
        await showSuccessMessage(
          'ACTIVATE_SALE',
          'Your `Activate Sale`\'s request has been proceed',
          async () => {
            try {
              const documents = [];
              const data = (await this.service.find({
                filter: {
                  token: { $eq: this.token },
                  sale_date_id: { $eq: this.date }
                },
                limit: 1
              }))[0];
              if (data) {
                const newData = {
                  ...data,
                  is_active: true,
                  status: 'activated',
                  activated_at: new Date()
                };
                documents.push(newData);
              }

              const yesterdayDate = moment
                .utc(this.todayDate)
                .add(-1, 'day')
                .toDate()
                .toISOString()
                .split('T')[0];

              const yesterdayData = (await this.service.find({
                filter: {
                  token: { $eq: this.token },
                  sale_date_id: { $eq: yesterdayDate },
                  is_active: { $eq: true }
                },
                limit: 1
              }))[0];
              if (yesterdayData) {
                const newYesterdayData = {
                  ...yesterdayData,
                  status: 'timed',
                  timed_at: new Date()
                };
                documents.push(newYesterdayData);
              }
              console.log('documents', documents)
              await this.service.updateDocuments(documents);
              this.triggerRefreshData();
            } catch (e) {
              console.error(e)
            }
          }
        );
      } catch (e) {
        console.error(e)
      }
      this.activateSale.loading = false;
    },
    async requestSendClientsToDaily() {
      this.sendClientsToDaily.loading = true;
      try {
        let data = []
        try {
          data = await MongoService.sales.checkBeforeSendToDaily()
        } catch (e) {
          await MessageDialog.showErrorMessage({ title: 'Error !', text: e && e.message })
        }
        console.log('data', data)
        data = getProp(data, '[0]', {})
        const items = Object.keys(data).map(key => {
          const item = data[key]
          return flattenObject({
            'account_id': key,
            ...item
          })
        })
        this.sendClientsToDaily.dialog.data = items
        let submitted = true
        if (items.length) {
          const { promise } = await this.$refs.sendClientsToDailyDialog.activate()
          submitted = await promise
        }
        if (submitted) {
          await new Promise(resolve => setTimeout(resolve, 350))
          await showSuccessMessage(
            'SEND_CLIENTS_TO_DAILY',
            'Your `Send clients to daily`\'s request has been proceed',
            async () => {
              await MongoService.sales.sendClientsToDaily({date: this.date, currency: this.token});
              this.setActionTimeout(this.sendClientsToDaily, 30).then(
                this.triggerRefreshData
              );
            }
          );
        }
      } catch (e) {}
      this.sendClientsToDaily.loading = false;
    },
    async requestNotifySaleBalance() {
      this.notifySaleBalance.loading = true;
      try {
        const {
          notificationName,
          message
        } = await MongoService.notifier.notifySaleBalance();
        this.setActionTimeout(this.notifySaleBalance, 3);
        MessageDialog.showSuccessMessage(
          parseNotificationResult({ notificationName, message })
        );
      } catch (e) {
        MessageDialog.showErrorMessage({ text: e.toString() });
      }
      this.notifySaleBalance.loading = false;
    },
    async requestSendDailyToExchanges() {
      this.sendDailyToExchanges.loading = true;
      try {
        let data = {};
        try {
          data = await MongoService.sales.checkBeforeSendToExchanges();
        } catch (e) {
          await MessageDialog.showErrorMessage({
            title: 'Error !',
            text: e && e.message
          });
        }
        const items = Object.keys(data).map(accountId => {
          const account = data[accountId];
          const balances = getProp(account, 'balances', []);
          return {
            account_id: accountId,
            ...account,
            totals: {
              balance_USD: balances.reduce(
                (sum, item) => sum + item['balance_USD'],
                0
              ),
              available_USD: false
            },
            success: balances.some(item => !item['isEmpty']),
            incorrect: false
          };
        });
        this.sendDailyToExchanges.dialog.data = items;
        const {
          promise
        } = await this.$refs.sendDailyToExchangesDialog.activate();
        const submitted = await promise;
        if (submitted) {
          await new Promise(resolve => setTimeout(resolve, 350));
          await showSuccessMessage(
            'SEND_DAILY_TO_EXCHANGES',
            'Your `Send daily to exchanges`\'s request has been proceed',
            async () => {
              await MongoService.sales.sendDailyToExchanges({date: this.date, currency: this.token});
              this.setActionTimeout(this.sendDailyToExchanges, 30).then(
                this.triggerRefreshData
              );
            }
          );
        }
      } catch (e) {}
      this.sendDailyToExchanges.loading = false;
    },
    async requestUpdateSpreadsheet() {
      this.updateSpreadsheet.loading = true;
      try {
        await showSuccessMessage(
          'UPDATE_SPREADSHEET',
          'Your `Update Spreadsheet`\'s request has been proceed',
          async () => {
            await MongoService.sales.updateSpreadsheet();
          }
        );
      } catch (e) {}
      this.updateSpreadsheet.loading = false;
    },
    async requestNotifierSummaryToTelegram(token) {
      this.notifierSummaryToTelegram.loading = true;
      try {
        const {
          notificationName,
          message
        } = token === 'XRP' ? await MongoService.notifier.notifierSummaryToTelegram() : await MongoService.notifier.notifierSummaryToTelegram2()
        MessageDialog.showSuccessMessage(
          parseNotificationResult({ notificationName, message })
        );
      } catch (e) {
        MessageDialog.showErrorMessage({ text: e.toString() });
      }
      this.notifierSummaryToTelegram.loading = false;
    },
    async requestSalesResults() {
      this.salesResults.loading = true;
      try {
        await showSuccessMessage(
          'SALES_RESULTS',
          'Your `Sales Results`\'s request has been proceed',
          async () => {
            await MongoService.sales.salesResults({date: this.date, currency: this.token});
            this.triggerRefreshData();
          }
        );
      } catch (e) {}
      this.salesResults.loading = false;
    },
    async requestWakeUpDispatch() {
      this.wakeUpDispatch.loading = true;
      try {
        await showSuccessMessage(
          'WAKEUP_DISPATCH',
          'Your `Wake Up Dispatch`\'s request has been proceed',
          async () => {
            await MongoService.sales.wakeUpDispatch({date: this.date, currency: this.token});
            this.triggerRefreshData();
          }
        );
      } catch (e) {}
      this.wakeUpDispatch.loading = false;
    },
    async requestDispatch() {
      this.dispatch.loading = true;
      try {
        await showSuccessMessage(
          'DISPATCH',
          'Your `Dispatch`\'s request has been proceed',
          async () => {
            await MongoService.sales.dispatch({date: this.date, currency: this.token});
            this.triggerRefreshData();
          }
        );
      } catch (e) {}
      this.dispatch.loading = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.button-container {
  margin-top: 1em;
}
.v-stepper.v-stepper--vertical .v-stepper__content {
  border-left: none;
  margin-left: -14px;
}
.stepper-content-row {
  display: flex;
  > .button-container {
    flex: 0 0 auto;
  }
  > .details-container {
    flex: 1 1 auto;
  }
  &.d-block {
    display: block;
  }
}
</style>
